/**
 * Types pour l'application Form
 * Alignes avec le schema Convex
 */

import type { Id, Doc } from "../../../../convex/_generated/dataModel";
import type { Infer } from "convex/values";
import {
  TypeEvalEnum,
  StatutGlobalEnum,
  TemplateFormEnum,
  formReponseAutodiagValidator,
  formReponseEgogrammeValidator,
  formReponseCopsoq3Validator,
  formReponsePamiValidator,
} from "../../../../convex/schema";

// Re-export enums pour utilisation dans le frontend
export { TypeEvalEnum, StatutGlobalEnum, TemplateFormEnum };

export type Evaluation = Doc<"evaluations">;
// Embedded types from schema (not tables, so not in Doc<>)
export type DonneesForm = Extract<Evaluation["donnees"], { type: "form" }>;
export type FormsEvaluation = Omit<Evaluation, "donnees"> & {
  donnees: DonneesForm;
};
export type FormReponses = DonneesForm["reponses"];

// Types spécifiques par template
export type AutodiagReponse = Infer<typeof formReponseAutodiagValidator>;
export type AutodiagReponses = Record<string, AutodiagReponse>;
export type EgogrammeReponse = Infer<typeof formReponseEgogrammeValidator>;
export type EgogrammeReponses = Record<string, EgogrammeReponse>;
export type Copsoq3Reponse = Infer<typeof formReponseCopsoq3Validator>;
export type Copsoq3Reponses = Record<string, Copsoq3Reponse>;
export type PamiReponse = Infer<typeof formReponsePamiValidator>;
export type PamiReponses = Record<string, PamiReponse>;

/**
 * Type pour les reponses d'erreur du backend
 */
export interface BackendError {
  erreur: string;
  bloqueJusquA?: number;
}

/**
 * Resultat d'une query/mutation qui peut echouer
 */
export type BackendResult<T> = T | BackendError;

/**
 * Type guard pour verifier si c'est une erreur
 */
export function isBackendError(result: unknown): result is BackendError {
  return (
    typeof result === "object" &&
    result !== null &&
    "erreur" in result &&
    typeof (result as BackendError).erreur === "string"
  );
}

export interface FormTemplateProps {
  token: string;
  parcoursId: string;
  editable: boolean;
  evaluation: FormsEvaluation;
  onComplete?: () => void;
}
